import { Theme } from "@radix-ui/themes";
import { usePage } from "@inertiajs/react";
import { type ComponentProps } from "react";
import type { SharedProps } from "@/types";

type AccentColor = ComponentProps<typeof Theme>["accentColor"];

// The one place the app's accent is chosen; the layouts render it at their
// root. Pages never set it. A <Theme> a component still needs, for a primitive
// portal that renders outside the root's div, is left bare and inherits all of
// this through context.
//
// Driftables is pink. A brand borrows the Radix scale nearest its colour
// (BrandPalette), whose solid steps the layout's brand <style> pins to the
// brand's own hex; grayColor stays "auto", Radix's pairing for that scale.
//
// The server-rendered pages (Devise) have no React to render this, so
// ThemeHelper#radix_theme_attributes says the same thing in Ruby. Change one,
// change both.
//
// No `appearance`: light or dark is the `.light`/`.dark` class on <html> (see
// layouts/inertia.html.erb and shared/appearance.ts), which Radix inherits.
export default function AppTheme(props: ComponentProps<typeof Theme>) {
  const { brand } = usePage<SharedProps>().props;
  const accentColor = (brand?.accent ?? "pink") as AccentColor;

  return <Theme accentColor={accentColor} {...props} />;
}
